export enum ContactDetailsState {
	View = 1,
	Edit = 2,
}
